import {originClick} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
import {useTrackingClient} from '../context/TrackingClientContext';

export const useTrackOriginClick = () => {
  const TrackingClient = useTrackingClient();

  return useCallback(
    (origin: originClick) => {
      if (!TrackingClient) {
        return;
      }
      TrackingClient.trackOriginClick({origin});
    },
    [TrackingClient],
  );
};
